import { Button, Result } from "antd";
import { Link } from "react-router-dom";

export const PageNotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Link to={"/"}>
          <Button className="bg-customColor text-white hover:!bg-white border-none hover:!text-customColor font-medium text-[14px] !rounded !py-4 h-[35px] ">
            Back Home
          </Button>
        </Link>
      }
    />
  );
};
